import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('rect', { x: '9.38', y: '16.74', width: '3.86', height: '1.3' }),
  React.createElement('rect', { x: '14.8', y: '16.74', width: '7.81', height: '1.3' }),
  React.createElement('path', { d: 'M27.63,7.15a2.54,2.54,0,0,0-2.54-2.54H6.91a2.54,2.54,0,0,0-.86,4.93A2.73,2.73,0,0,0,6,10v14.7a2.65,2.65,0,0,0,2.65,2.65h14.7A2.65,2.65,0,0,0,26,24.74V10a2.73,2.73,0,0,0-.05-.5A2.55,2.55,0,0,0,27.63,7.15ZM24.7,10v2.88H7.3V10A1.36,1.36,0,0,1,8.65,8.69h14.7A1.36,1.36,0,0,1,24.7,10ZM7.3,14.22H24.7v6.35H7.3ZM23.35,26.09H8.65A1.35,1.35,0,0,1,7.3,24.74V21.87H24.7v2.87A1.35,1.35,0,0,1,23.35,26.09Zm2-17.75a2.63,2.63,0,0,0-2-1H8.65a2.67,2.67,0,0,0-2,1,1.23,1.23,0,0,1,.28-2.43H25.09a1.23,1.23,0,0,1,.27,2.43Z' })
));